var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "app-main-inner app-main-page basic-data china-post-product-configuration"
    },
    [
      _c(
        "el-container",
        { staticClass: "app-main-inner-row" },
        [
          _c(
            "el-aside",
            {
              staticClass: "inner-box",
              staticStyle: {
                width: "fit-content",
                height: "calc(100vh - 210px)",
                "overflow-x": "hidden",
                "margin-top": "60px"
              }
            },
            [
              _c(
                "el-radio-group",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" },
                  attrs: { no: "navigationBars" },
                  on: { change: _vm.barChange },
                  model: {
                    value: _vm.currentBar,
                    callback: function($$v) {
                      _vm.currentBar = $$v
                    },
                    expression: "currentBar"
                  }
                },
                _vm._l(_vm.navigationBars, function(item, index) {
                  return _c(
                    "el-radio",
                    {
                      key: index,
                      staticStyle: { "line-height": "30px" },
                      attrs: { label: item.value }
                    },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-main",
            { staticStyle: { padding: "0px", flex: "1" } },
            [
              _c("allow-sale-product", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentBar === "AllowSaleProduct",
                    expression: "currentBar === 'AllowSaleProduct'"
                  }
                ],
                ref: "allowSaleProduct",
                attrs: { no: "allowSaleProduct" }
              }),
              _c("new-charge-group", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentBar === "NewChargeGroup",
                    expression: "currentBar === 'NewChargeGroup'"
                  }
                ],
                ref: "newChargeGroup",
                attrs: { no: "newChargeGroup" }
              }),
              _c("charge-mapping", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentBar === "ChargeMapping",
                    expression: "currentBar === 'ChargeMapping'"
                  }
                ],
                ref: "chargeMapping",
                attrs: { no: "chargeMapping" }
              }),
              _c("exclusion-office", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentBar === "ExclusionOffice",
                    expression: "currentBar === 'ExclusionOffice'"
                  }
                ],
                ref: "ExclusionOffice",
                attrs: { no: "ExclusionOffice" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }